module.exports = __webpack_public_path__ + "static/img/rogercunha.60ffeb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rogercunha.png
// module id = WnTJ
// module chunks = 0